// extracted by mini-css-extract-plugin
export var actionButton = "_k5-t";
export var buttonContainer = "_k5-0";
export var buttonContainer2 = "_k5-1";
export var buttonSection = "_k5-2";
export var details = "_k5-3";
export var dropdownItem = "_k5-5";
export var dropdownItemsContainer = "_k5-4";
export var fileInput = "_k5-r";
export var headerButton = "_k5-6";
export var icon = "_k5-7";
export var input = "_k5-8";
export var macroListItem = "_k5-9";
export var mainContent = "_k5-a";
export var microText = "_k5-b";
export var modal = "_k5-w";
export var optionsButton = "_k5-c";
export var paperclip = "_k5-s";
export var pillContent = "_k5-d";
export var preview = "_k5-e";
export var preview2 = "_k5-f";
export var quillEditor = "_k5-q";
export var selectedMacro = "_k5-g";
export var sidebar = "_k5-h";
export var sidebarHeader = "_k5-j";
export var sidebarList = "_k5-i";
export var sidebarListItem = "_k5-k";
export var sidebarSearch = "_k5-l";
export var snoozeDurationWrapper = "_k5-v";
export var statusPillContainer = "_k5-m";
export var tagsContainer = "_k5-n";
export var unselectedMacro = "_k5-o";
export var variable = "_k5-u";
export var wrapper = "_k5-p";